<fui-navigation-branch id="branch-{{index}}" *ngFor="let branch of branches; let index = index" [branch]="branch"></fui-navigation-branch>
